var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ib-toggle",class:{isReduce: _vm.isReduce == true && _vm.isMouseEnter == false}},[_c('div',{staticClass:"toggle-item center-point",class:{
      active: _vm.agentRole == 'CUSTOMER',
      pointer: _vm.agentRole == 'IB'
    },on:{"click":_vm.customerHandle}},[_vm._v("\n    "+_vm._s(_vm.$t('HeaderCom.userCenter'))+"\n  ")]),_c('div',{staticClass:"toggle-item back-table",class:{
      active: _vm.agentRole == 'IB',
      pointer: _vm.agentRole == 'CUSTOMER'
      },on:{"click":_vm.ibHandle}},[_vm._v("\n    "+_vm._s(_vm.$t('Agent_Backstage'))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }